// Mock data for Edil Service 2.0 SRL

export const companyInfo = {
  name: "Edil Service 2.0 SRL",
  slogan: "La qualità e la convenienza in unico luogo",
  tagline: "Rivenditori & Distributori Edili Autorizzati",
  description: "Qualità, affidabilità e supporto per professionisti e privati",
  address: "Contrada Pezza La Pera di Sopra, San Ferdinando di Puglia (BT)",
  phone: "0883 620626",
  whatsappBusiness: "0883620626",
  whatsappTech: "3482988266",
  email: "edilserviceduepuntozerosrl@gmail.com",
  location: {
    lat: 41.3089,
    lng: 16.0789,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Contrada+Pezza+La+Pera+di+Sopra+San+Ferdinando+di+Puglia+BT"
  },
  hours: {
    weekdays: "Lunedì–Venerdì: 07:00–12:30 / 14:00–17:30",
    saturday: "Sabato: 07:00–13:00",
    sunday: "Domenica: Chiuso"
  }
};

export const services = [
  {
    id: 1,
    title: "Vendita Materiali da Costruzione",
    description: "Ampia gamma di materiali edili per ogni esigenza di cantiere",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Ferramenta e Attrezzature",
    description: "Attrezzature professionali e ferramenta per artigiani e imprese",
    icon: "Wrench"
  },
  {
    id: 3,
    title: "Vernici e Pitture Professionali",
    description: "Vernici di alta qualità per interni ed esterni",
    icon: "Paintbrush"
  },
  {
    id: 4,
    title: "Dispositivi di Sicurezza (DPI)",
    description: "Equipaggiamento per la sicurezza sul lavoro certificato",
    icon: "Shield"
  },
  {
    id: 5,
    title: "Impermeabilizzazione",
    description: "Soluzioni professionali per l'impermeabilizzazione",
    icon: "Droplets"
  },
  {
    id: 6,
    title: "Consulenza Tecnica per Cantieri",
    description: "Supporto specializzato per la realizzazione dei vostri progetti",
    icon: "Headphones"
  }
];

export const products = [
  {
    id: 1,
    category: "Materiali Base",
    items: ["Cemento", "Calce", "Laterizi", "Mattoni"],
    icon: "Boxes"
  },
  {
    id: 2,
    category: "Materiali Strutturali",
    items: ["Ferro per cemento armato", "Travi", "Pilastri"],
    icon: "Layers"
  },
  {
    id: 3,
    category: "Impiantistica",
    items: ["Tubi", "Raccordi", "Sistemi idraulici"],
    icon: "Pipette"
  },
  {
    id: 4,
    category: "Finiture",
    items: ["Vernici professionali", "Pitture", "Rivestimenti"],
    icon: "Palette"
  },
  {
    id: 5,
    category: "Attrezzature",
    items: ["Utensili da lavoro", "Macchinari", "Accessori"],
    icon: "Hammer"
  }
];

export const agricoltura = {
  title: "Settore Agricolo",
  description: "Soluzioni complete per l'agricoltura moderna",
  products: [
    {
      id: 1,
      name: "Innesti",
      description: "Innesti professionali di alta qualità per ogni esigenza agricola"
    }
  ]
};

export const brandsRappresentanza = [
  { name: "CVR", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/zehao0it_1ffb31c1-8b7e-4025-9098-997fae2ee49a.jpeg", website: "https://cvr-italy.com" },
  { name: "Icobit", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/90ci3kud_312d1fbe-1a2b-48b7-b9ed-cd8a7c5d9557.jpeg", website: "https://icobit.com" },
  { name: "Loggia", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/xb7atv1r_35862c7f-c3db-4453-a925-54ed17a41c18.jpeg", website: "https://www.loggia.it" },
  { name: "Kimia", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/uplambrd_IMG_1509.png", website: "https://www.kimia.it" }
];

export const brandsDistribuzione = [
  { name: "Sikkens", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/zte4w9j3_1999f825-606a-4e71-8ccc-91c71331b3e1.jpeg", website: "https://www.sikkens.it/it" },
  { name: "Rofix", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/4zmjbx6h_c7f5a80e-1881-45e4-b0b4-1b8c41687f94.jpeg", website: "https://www.roefix.it" },
  { name: "Akifix", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/2pa0dbfh_a343406b-adba-405a-90d7-5b9604676488.jpeg", website: "https://www.akifix.it" },
  { name: "Gyproc", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/ak9tste8_aa0b56cc-5715-4d14-8271-2b0cbe0464cf.jpeg", website: "https://www.gyproc.it" },
  { name: "AREA 51", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/fnj4shxj_b86fd0d4-c37c-41b5-8a65-bb27426118f2.jpeg", website: "https://www.colorificioarea51.it" },
  { name: "Grigolin", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/g78il5k7_85616355-6f36-4759-8f64-da9a35cbf077.jpeg", website: "https://www.grigolin.it" },
  { name: "Knauf", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/lel1fmxr_IMG_1510.jpeg", website: "https://knauf.com/it-IT" },
  { name: "Mapei", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/uezvg3ne_a9c4f449-cd9e-4c95-a793-4b0d19aa742f.jpeg", website: "https://www.mapei.com/it" },
  { name: "Herbol", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/aejva4i9_5bb90661-58db-4519-b88b-3a0268d33e78.jpeg", website: "https://www.herbol.it" },
  { name: "Weber", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/bydgx58d_a2f5dcec-3999-4b9e-8b25-67d740152cd0.jpeg", website: "https://www.it.weber" },
  { name: "Fischer", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/had8vzci_a531f594-2f79-4121-97bd-b56eb878f8c8.jpeg", website: "https://www.fischer.it/it-it" },
  { name: "Di Maria", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/c2n989rk_aeeb7238-96cb-4d6d-b873-7dd6a787c9a0.jpeg", website: "https://www.gdm-dimaria.com" },
  { name: "Panfilm", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/d6bdrghd_e4527ada-2963-4d5b-b0d4-68afa3b8164d.jpeg", website: "https://www.panfilm.it" },
  { name: "Sola", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/uc63pixm_IMG_1516.gif", website: "https://www.sola.at/it-it" },
  { name: "Raimondi", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/871dwl40_faef14f8-d386-49d4-bc03-114dff7a2744.jpeg", website: "https://www.raimondispa.com" },
  { name: "Diana Pennelli", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/xb1apmfh_1bde39cc-48e2-4f83-a1cd-e3938a2956da.jpeg", website: "http://www.pennellidiana.it" },
  { name: "Pavan Ernesto & Figli", logo: "https://via.placeholder.com/200x80/ffffff/16a34a?text=PAVAN", website: "https://www.pavanspa.it" },
  { name: "Profitek", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/jub0x6k3_a3571a07-50f9-4db8-a76d-9809ef141eb8.jpeg", website: "https://www.profilitec.com/it/" },
  { name: "Ermetika", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/zp662rsp_46c9cb5f-36a3-4604-827d-0697952f58cf.jpeg", website: "https://www.ermetika.com/it" },
  { name: "Diadora Utility", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/ub8r6eyq_0778ec0c-b705-4b5e-9991-d2fe6d32082e.jpeg", website: "https://www.diadorautility.com" },
  { name: "Lampiflex", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/6u3dkpba_f5ec2ece-17c1-407a-9cde-abdc47be40ee.jpeg", website: "https://www.lampiflex.it" },
  { name: "ItalCover", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/7weyacr1_72803eb5-6f71-4b51-b05f-25c10050ece6.jpeg", website: "https://www.italcover.net" },
  { name: "Sigma", logo: "https://customer-assets.emergentagent.com/job_edil-service/artifacts/jtehvyzv_9896a875-15dd-43ca-bb5d-631acc1cd7d2.jpeg", website: "https://www.sigmaitalia.com" }
];

export const brands = [...brandsRappresentanza, ...brandsDistribuzione];

export const aboutCompany = {
  title: "Chi Siamo",
  description: "Edil Service 2.0 SRL è un'azienda leader nella distribuzione di materiali edili a San Ferdinando di Puglia. Con anni di esperienza nel settore, siamo il punto di riferimento per imprese edili, artigiani, agricoltori e privati che cercano qualità, convenienza e professionalità.",
  values: [
    {
      title: "Qualità Garantita",
      description: "Lavoriamo solo con i migliori marchi del settore per garantire prodotti di alta qualità"
    },
    {
      title: "Esperienza",
      description: "Anni di esperienza al servizio del territorio e dei professionisti"
    },
    {
      title: "Convenienza",
      description: "Prezzi competitivi senza compromessi sulla qualità"
    },
    {
      title: "Assistenza",
      description: "Consulenza tecnica specializzata per ogni tua esigenza"
    }
  ]
};

// Mock function for contact form submission
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form data:", formData);
      resolve({ success: true, message: "Richiesta inviata con successo!" });
    }, 1000);
  });
};
